// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"d028d558","43":"e26a9691","580":"e5228693","678":"f28bd4c1","713":"3bea45d3","879":"ec562377","950":"e05926ed"}[chunkId] + ".chunk.js";
};